import React, { useEffect, useState } from "react";
import { Dropdown } from "primereact";

import { useBuscarVentasPorItemGrafico, useBuscarRentabilidadPorVendedorGrafico } from "../Services/facturacion-service";
import { buscar } from "../../../Commons/Scripts/Utils/Buscar";
import { URL_CATEGORIAS, URL_SUB_CATEGORIAS, URL_FAMILIAS } from "../../../Inventario/Scripts/Utils/constantes";
import { URL_TIENDAS_GRID} from "../Utils/constantes"

const OpcionesPeriodo = [
    { label: "Todos", value: "-1" },
    { label: "Hoy", value: "hoy" },
    { label: "Esta semana", value: "semana" },
    { label: "Este mes", value: "mes" },
    { label: "Este trimestre", value: "trimestre" },
    { label: "Este año", value: "anual" },
    { label: "Año anterior", value: "anual_anterior" }
];

const OpcionesTop = [
    { label: "Top 10", value: 10 },
    { label: "Top 25", value: 25 },
    { label: "Top 50", value: 50 },
    { label: "Todos", value: -1 }
]
const OpcionesTipo = [
    { label: "Producto", value: 0 },
    { label: "Categoria", value: 1 },
    { label: "SubCategoria", value: 2 },
    { label: "Familia", value: 3 }
]

const FiltroValorDefault = { IdSec: null, Descripcion: "Todos" };

const PieChart = ({ id, data, title, moneda, url }) => {
    function createGrafico() {
        const transformedData = data.map(item => ({
            name: item.Desc,
            value: item.Monto,
            idsec: item.IdSec
        }));

        const chartDom = document.getElementById(id);
        const chart = echarts.init(chartDom, null, { width: "849", height: "390" });

        const options = {
            title: {
                text: title,
                left: "center",
            },
            tooltip: {
                trigger: "item",
                formatter: function (params) {
                    return `<b>${params.name}</b> <br/> ${moneda} ${Citrus.Convert.toCurrencyNoSimbolo(params.value)} (${params.percent}%)`;
                }
            },
            legend: {
                type: 'scroll',
                orient: "vertical",
                left: 'left',
                formatter: function (name) {
                    if (name.length > 25) {
                        return name.slice(0, 25) + '...';
                    }
                    return name;
                }
            },
            color: ['#3fb1e3', '#91cc75', '#fac858', '#ee6666', '#5c7bd9', '#9f8fef'],
            series: [
                {
                    type: 'pie',
                    radius: '50%',
                    label: {
                        fontSize: 12,
                        formatter(param) {
                            return param.percent + '%';
                        },
                        overflow: 'breakAll'
                    },
                    data: transformedData,
                    itemStyle: {
                        borderColor: "#fff",
                        borderWidth: 1,
                    },
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    }
                }
            ]
        };

        chart.setOption(options);
        chart.on('click', function (params) {
            if (url != null && params != null && params.data != null && params.data.idsec) {
                window.open(`${url}?IdSec=${params.data.idsec}`, "_blank");
            }
        });
    }

    useEffect(() => {
        if (data) {
            createGrafico();
        }
    }, [data, id, title, moneda])

    return <div id={id} className="chart"></div>
};

const Filters = ({ where, setWhere, periodo, setPeriodo, top, setTop, loading, tienda, setTienda, opcionesTienda, categoria, setCategoria, opcionesCategoria, subCategoriaWhere, setSubCategoriaWhere, subCategoria, opcionesSubCategoria, setSubCategoria, familiaWhere, setFamiliaWhere, familia, setFamilia, opcionesFamilia, setTipo, tipo, OpcionesTipo }) => {
    const handleChangePeriodo = (e) => {
        setPeriodo(e.value);
        setWhere({ where: { ...where.where, Periodo: e.value } });
    };

    const handleChangeTop = (e) => {
        setTop(e.value);
        setWhere({ where: { ...where.where, Top: e.value } });
    };

    const handleChangeTipo = (e) => {
        setTipo(e.value);
        setCategoria(FiltroValorDefault);
        setSubCategoria(FiltroValorDefault);
        setFamilia(FiltroValorDefault);
        setWhere({ where: { ...where.where, Tipo: e.value, CategoriaIdSec: FiltroValorDefault.IdSec, SubCategoriaIdSec: FiltroValorDefault.IdSec, FamiliaIdSec: FiltroValorDefault.IdSec } });
    };

    const handleChangeTienda = (e) => {
        setTienda(e.value);
        setWhere({ where: { ...where.where, TiendaIdSec: e.value.IdSec } });
    };

    const handleChangeCategoria = (e) => {
        setCategoria(e.value);
        setSubCategoria(FiltroValorDefault);
        setFamilia(FiltroValorDefault);
        setSubCategoriaWhere({ where: { ...subCategoriaWhere.where, CategoriaIdSec: e.value.IdSec } });
        setFamiliaWhere({ where: { ...familiaWhere.where, SubCategoriaIdSec: FiltroValorDefault.IdSec } });
        setWhere({ where: { ...where.where, CategoriaIdSec: e.value.IdSec, SubCategoriaIdSec: FiltroValorDefault.IdSec, FamiliaIdSec: FiltroValorDefault.IdSec } }); // TODO: PENDIENTE EN EL BACKEND
    }

    const handleChangeSubCategoria = (e) => {
        setSubCategoria(e.value);
        setFamilia(FiltroValorDefault);
        setFamiliaWhere({ where: { ...familiaWhere.where, SubCategoriaIdSec: e.value.IdSec } });
        setWhere({ where: { ...where.where, SubCategoriaIdSec: e.value.IdSec, FamiliaIdSec: FiltroValorDefault.IdSec } }); // TODO: PENDIENTE EN EL BACKEND
    }

    const handleChangeFamilia = (e) => {
        setFamilia(e.value);
        setWhere({ where: { ...where.where, FamiliaIdSec: e.value.IdSec } }); // TODO: PENDIENTE EN EL BACKEND
    }

    return (
        <div style={{ display: "flex", marginTop: "30px" }}>
            <div className="card flex justify-content-center" style={{ marginRight: "5px" }}>
                <span className="p-float-label">
                    <Dropdown
                        inputId="dd-periodo"
                        value={periodo}
                        onChange={handleChangePeriodo}
                        options={OpcionesPeriodo}
                        optionLabel="label"
                        style={{ minWidth: "150px" }}
                        disabled={loading}
                    />
                    <label htmlFor="dd-periodo">Periodo</label>
                </span>
            </div>
            <div className="card flex justify-content-center" style={{ marginRight: "5px" }}>
                <span className="p-float-label">
                    <Dropdown
                        inputId="dd-top"
                        value={top}
                        onChange={handleChangeTop}
                        options={OpcionesTop}
                        optionLabel="label"
                        disabled={loading}
                    />
                    <label htmlFor="dd-top">Top</label>
                </span>
            </div>
            <div className="card flex justify-content-center" style={{ marginRight: "5px" }}>
                <span className="p-float-label">
                    <Dropdown
                        inputId="dd-Tienda"
                        value={tienda}
                        onChange={handleChangeTienda}
                        options={opcionesTienda}
                        optionLabel="Descripcion"
                        disabled={loading}
                    />
                    <label htmlFor="dd-Tienda">Tienda</label>
                </span>
            </div>
            <div className="card flex justify-content-center" style={{ marginRight: "5px" }}>
                <span className="p-float-label">
                    <Dropdown
                        inputId="dd-Tipo"
                        value={tipo}
                        onChange={handleChangeTipo}
                        options={OpcionesTipo}
                        optionLabel="label"
                        disabled={loading}
                    />
                    <label htmlFor="dd-Tipo">Tipo</label>
                </span>
            </div>
            {tipo == 0 && <div className="card flex justify-content-center" style={{ marginRight: "5px" }}>
                <span className="p-float-label">
                    <Dropdown inputId="dd-Categoria" value={categoria} onChange={handleChangeCategoria} options={opcionesCategoria} optionLabel="Descripcion" disabled={loading} />
                    <label htmlFor="dd-Categoria">Categoría</label>
                </span>
            </div>}
            {tipo == 0 && <div className="card flex justify-content-center" style={{ marginRight: "5px" }}>
                <span className="p-float-label">
                    <Dropdown inputId="dd-SubCategoria" value={subCategoria} onChange={handleChangeSubCategoria} options={opcionesSubCategoria} optionLabel="Descripcion" disabled={loading} />
                    <label htmlFor="dd-SubCategoria">Subcategoría</label>
                </span>
            </div>}
            {tipo == 0 && subCategoria?.IdSec != null && <div className="card flex justify-content-center">
                <span className="p-float-label">
                    <Dropdown inputId="dd-Familia" value={familia} onChange={handleChangeFamilia} options={opcionesFamilia} optionLabel="Descripcion" disabled={loading} />
                    <label htmlFor="dd-Familia">Familia</label>
                </span>
            </div>}
        </div>
    );
}

export const GraficoRentabilidad = () => {
    const moneda = window.monedaPredeterminada;

    const [where, setWhere] = useState({ where: { Periodo: "mes", Top: 10 } });
    const [periodo, setPeriodo] = useState("mes");
    const [top, setTop] = useState(10);

    const [tipo, setTipo] = useState(0);

    const [tienda, setTienda] = useState({ IdSec: 0, Descripcion: "Todos" });
    const [opcionesTienda, setOpcionesTienda] = useState([{ IdSec: 0, Descripcion: "Todos" }]);

    const [categoria, setCategoria] = useState(FiltroValorDefault);
    const [opcionesCategoria, setOpcionesCategoria] = useState([FiltroValorDefault]);

    const [subCategoria, setSubCategoria] = useState(FiltroValorDefault);
    const [subCategoriaWhere, setSubCategoriaWhere] = useState({ where: { Estatus: 'A', EsPaginable: false } });
    const [opcionesSubCategoria, setOpcionesSubCategoria] = useState([FiltroValorDefault]);

    const [familia, setFamilia] = useState(FiltroValorDefault);
    const [familiaWhere, setFamiliaWhere] = useState({ where: { Estatus: 'A', EsPaginable: false } });
    const [opcionesFamilia, setOpcionesFamilia] = useState([FiltroValorDefault]);

    const {
        data: dataItemsVendidos,
        loading: cargandoItemsVendidos,
        error: errorItemsVendidos,
    } = useBuscarVentasPorItemGrafico(where);

    const {
        data: dataRentabilidadVendedor,
        loading: cargandoRentabilidadVendedor,
        error: errorRentabilidadVendedor,
    } = useBuscarRentabilidadPorVendedorGrafico(where);

    const loading = cargandoItemsVendidos || cargandoRentabilidadVendedor;

    useEffect(() => {
        let tiendaWhere = { where: { Estatus: 'A', EsPaginable: false } };

        buscar(URL_TIENDAS_GRID, tiendaWhere).then((data) => {
            const opciones = data.Resultados?.map((item) => {
                return { IdSec: item.id, Descripcion: item.text };
            });

            setOpcionesTienda([...opcionesTienda, ...opciones])
        });

        let categoriaWhere = { where: { Estatus: 'A', EsPaginable: false } };
        buscar(URL_CATEGORIAS, categoriaWhere).then((data) => {
            const opciones = data.Resultados?.map((item) => {
                return { IdSec: item.IdSec, Descripcion: item.Nombre };
            });
            setOpcionesCategoria([...opcionesCategoria, ...opciones])
        });
    }, []);

    useEffect(() => {
        buscar(URL_SUB_CATEGORIAS, subCategoriaWhere).then((data) => {
            const opcionesDefecto = [FiltroValorDefault];
            const opciones = data.Resultados?.map((item) => {
                return { IdSec: item.IdSec, Descripcion: item.Nombre };
            });
            setOpcionesSubCategoria([...opcionesDefecto, ...opciones])
        });
    }, [subCategoriaWhere]);

    useEffect(() => {
        buscar(URL_FAMILIAS, familiaWhere).then((data) => {
            const opcionesDefecto = [FiltroValorDefault];
            const opciones = data.Resultados?.map((item) => {
                return { IdSec: item.IdSec, Descripcion: item.Nombre };
            });
            setOpcionesFamilia([...opcionesDefecto, ...opciones])
        });
    }, [familiaWhere]);


    if (errorItemsVendidos || errorRentabilidadVendedor) {
        return null;
    }

    return (
        <React.Fragment>
            <Filters where={where} setWhere={setWhere} periodo={periodo} setPeriodo={setPeriodo} top={top} setTop={setTop} loading={loading} tienda={tienda} setTienda={setTienda} opcionesTienda={opcionesTienda} categoria={categoria} opcionesCategoria={opcionesCategoria} setCategoria={setCategoria} subCategoriaWhere={subCategoriaWhere} setSubCategoriaWhere={setSubCategoriaWhere} subCategoria={subCategoria} opcionesSubCategoria={opcionesSubCategoria} setSubCategoria={setSubCategoria} familiaWhere={familiaWhere} setFamiliaWhere={setFamiliaWhere} familia={familia} setFamilia={setFamilia} opcionesFamilia={opcionesFamilia} setTipo={setTipo} tipo={tipo} OpcionesTipo={OpcionesTipo} />
            <div className="card flex justify-content-center">
                <div id="chart_engimat" className="card_row" style={{ marginTop: "50px" }}>
                    <PieChart id="chart_pie_ventas" data={dataItemsVendidos?.Resultados} title={dataItemsVendidos?.Titulo } moneda={moneda} url="/Inventario/item_edit.aspx" />
                    <PieChart id="chart_pie_rentabilidad" data={dataRentabilidadVendedor?.Resultados} title="Rentabilidad por Vendedor" moneda={moneda} url="/Facturacion/vendedor_edit.aspx" />
                </div>
            </div>
        </React.Fragment>
    );
}